import { ref } from 'vue'
import { useQueue } from '../../composables/useQueue'
import { AllPartsModel } from '../../models/AllParts'
import { DownloadImageData } from '../../models/AllParts'

const USE_QUEUE = true

export const partImageQueue = () => {
  const { queueError, queueSuccess, addToQueue } = useQueue({ networkRequired: true })
  const toGrab = ref<DownloadImageData[]>([])
  const addToDownloadAttachmentQueue = (data: DownloadImageData[]) => {
    console.log('queue data', data)
    toGrab.value = data
    if (USE_QUEUE) {
      void startPartImageQueue()
    }
  }
  const startPartImageQueue = async () => {
    for (const img of toGrab.value) {
      console.log('queue:', img)
      const fn = async () => {
        const onDevice = await AllPartsModel().imageOnDevice(img)
        if (!onDevice) {
          console.log(onDevice, `not on device, fetching ${img.name}`)
          await AllPartsModel().downloadPartImage(
            {
              id: img.id,
              name: img.name,
              link: img.link,
            },
            true
          )
        } else {
          console.log('onDevice', img)
        }
      }
      await addToQueue([], fn)
        .then(() => {
          queueSuccess()
        })
        .catch(() => {
          queueError()
        })
    }
  }

  return {
    addToDownloadAttachmentQueue,
  }
}
